module.exports = __webpack_public_path__ + "static/img/2.49b13fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/ltsj/2.png
// module id = hpFK
// module chunks = 1